<template>
  <SingleCourse />
</template>

<script>
import SingleCourse from '@/components/content/education/EditViewSingleEducation.vue'

export default {
  name: 'ContentCourseVerification',
  components: { SingleCourse }
}
</script>

<style scoped>

</style>
